import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { appShell as defaultAppShell } from '../../../theme/tokens/semantic';
import { radius as defaultRadius } from '../../../theme/tokens/radius';
import { shadows as defaultShadows } from '../../../theme/tokens/shadows';

export default function useAppShellTheme() {
  const theme = useTheme();

  return useMemo(
    () => ({
      semantic: theme.customTokens?.semantic,
      appShell: theme.customTokens?.semantic?.appShell ?? defaultAppShell,
      shadows: theme.customTokens?.shadows ?? defaultShadows,
      radius: theme.customTokens?.radius ?? defaultRadius,
      spacing: theme.spacing,
      breakpoints: theme.breakpoints,
    }),
    [theme]
  );
}
